let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8ZFeJ"), load("db2rf"), load("iQDXb"), load("6TF9J"), load("97s9d"), load("jjWia")]).then(() => parcelRequire('c8BWz'));